import { groupBy } from 'lodash';
import { getFramework } from '@/framework';
import { LIST_CHAR_ALL, type ILayerBehavior, type ITextLayerProps } from '@/version-types';

type Behaviors = Pick<ILayerBehavior, 'getTextInfo'>;

export const createFontBehaviors = (identity: string) => {
    const behaviors: Behaviors = {
        /**
         * 获取文本信息
         *
         * @param layer - 图层属性
         */
        getTextInfo(layer) {
            const layerData = layer.data as ITextLayerProps;
            const { textContents = [], text, fontFamily, listStyle, listStyleMaterial } = layerData;

            let temp: { fontFamily: string; text: string }[] = [];

            if (textContents.length > 0) {
                temp = textContents.map((item) => ({
                    fontFamily: item.fontFamily || layerData.fontFamily,
                    text: item.text,
                }));
            } else {
                temp = [{ fontFamily, text }];
            }

            if (listStyle) {
                // 若列表序号需要单独设置字体，这里需要收集列表序号的字体信息
                if (listStyleMaterial && listStyleMaterial.autoIncrement !== 'none' && listStyleMaterial.fontId) {
                    const fontList = getFramework(identity).getFontList();
                    const font = fontList.find((item) => String(item.id) === listStyleMaterial.fontId);

                    if (font) {
                        const fontName = font['font_name'];
                        temp.push({ fontFamily: fontName, text: LIST_CHAR_ALL });
                    }
                }

                // 由于仍可以切换为普通列表序号
                // 所以这里依然需要将列表序号以默认字体进行收集
                temp.push({ fontFamily, text: LIST_CHAR_ALL });
            }

            // 聚合相同字体
            const group = groupBy(temp, (item) => item.fontFamily);

            // HACK: https://jira.meitu.com/browse/MTXXPRO-63831
            // 在每种字体的文本后添加数字，以返回的子集不会应为集合内没有该字体导致 Safari 下子集异常
            const ret = Object.keys(group).map((fontFamily) => ({
                fontFamily,
                text: group[fontFamily].map((item) => item.text).join('') + '0123456789',
            }));

            return ret;
        },
    };

    return behaviors;
};
